import { Component, Injector, Input, OnInit, ViewChild, inject, output, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { JkBaseComponent } from '../jkbase/jkbase.component';
import { MaterialModule } from '../../material.module';

@Component({
  selector: 'app-titlebar',
  templateUrl: './titlebar.component.html',
  styleUrls: ['./titlebar.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ MaterialModule],
})
export class TitlebarComponent extends JkBaseComponent implements OnInit {
  override comType: string = 'titlebar';
  // TODO: Skipped for migration because:
  //  Class of this input is referenced in the signature of another class.
  @Input()
  onUser1Click?: (e?: any) => void;
  // TODO: Skipped for migration because:
  //  Class of this input is referenced in the signature of another class.
  @Input()
  onUser2Click?: () => void;
  // TODO: Skipped for migration because:
  //  Class of this input is referenced in the signature of another class.
  @Input()
  onUser3Click?: () => void;
  // TODO: Skipped for migration because:
  //  Class of this input is referenced in the signature of another class.
  @Input()
  onUser4Click?: () => void;
  // TODO: Skipped for migration because:
  //  Class of this input is referenced in the signature of another class.
  @Input()
  onUser5Click?: () => void;
  // TODO: Skipped for migration because:
  //  Class of this input is referenced in the signature of another class.
  @Input()
  user1Text: string = '';
  // TODO: Skipped for migration because:
  //  Class of this input is referenced in the signature of another class.
  @Input()
  user2Text: string = '';
  // TODO: Skipped for migration because:
  //  Class of this input is referenced in the signature of another class.
  @Input()
  user3Text: string = '';
  // TODO: Skipped for migration because:
  //  Class of this input is referenced in the signature of another class.
  @Input()
  user4Text: string = '';
  // TODO: Skipped for migration because:
  //  Class of this input is referenced in the signature of another class.
  @Input()
  user5Text: string = '';
  // TODO: Skipped for migration because:
  //  Class of this input is referenced in the signature of another class.
  @Input()
  homeVisible: boolean = true;
  // TODO: Skipped for migration because:
  //  Class of this input is referenced in the signature of another class.
  @Input()
  backVisible: boolean = true;
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input()
  user1Visible: boolean = false;
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input()
  user2Visible: boolean = false;
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input()
  user3Visible: boolean = false;
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input()
  user4Visible: boolean = false;
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input()
  user5Visible: boolean = false;
  //@Output() onTitleOptionClick = new EventEmitter<any>();
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() titleOptionsClick?: (e?: any) => void;
  readonly backClick = output();
  readonly homeClick = output();
  private router: Router;
  private locate: Location;
  constructor() {
    const injector = inject(Injector);

    super();
    this.router = injector.get(Router);
    this.locate = injector.get(Location);
    //this.navCtrl = injector.get(NavController);
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  initVisible() {
    if (this.onUser1Click) {
      this.user1Visible = true;
    }
    if (this.onUser2Click) {
      this.user2Visible = true;
    }
    if (this.onUser3Click) {
      this.user3Visible = true;
    }
    if (this.onUser4Click) {
      this.user4Visible = true;
    }
    if (this.onUser5Click) {
      this.user5Visible = true;
    }
  }
  menuClick(act: string) {
    /*if(this.page){
      this.page.titleOptionsClick(act);
      return;
    }*/
    if (this.titleOptionsClick) {
       this.titleOptionsClick(act);
    }
  }
  setRoot(url: string) {
    /*return this.navCtrl.navigateRoot(url, {
      animated: true,
      animationDirection: 'forward',
    });
    */
    if(this.homeClick){
      this.homeClick.emit();
    }
    this.router.navigate([url]);
  }
  doBack() {
    //this.navCtrl.back();
    if(this.backClick){
      this.backClick.emit();
    };
    this.locate.back();
  }
  user5Click() {
    if (this.onUser5Click) this.onUser5Click();
  }
  user4Click() {
    if (this.onUser4Click) this.onUser4Click();
  }
  user3Click() {
    if (this.onUser3Click) this.onUser3Click();
  }
  user2Click() {
    if (this.onUser2Click) this.onUser2Click();
  }
  user1Click() {
    if (this.onUser1Click) this.onUser1Click();
  }
  /*
  public showItemList(itemList: any, columnLabel: any) {
    this.jkgrid.open('明細',itemList, columnLabel);
  }
  */
}
